import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { SectionBg } from "@/components/SectionBg";

const STEPS = [
  { n: "01", title: "RESERVE", body: "Submit the registration form and choose whether to receive reminders." },
  { n: "02", title: "WATCH", body: "Attend the live educational workshop and follow the workbook." },
  { n: "03", title: "VERIFY", body: "Organize the questions and documents relevant to this offer." },
  { n: "04", title: "DECIDE", body: "Choose an individual next step without an obligation to apply." },
];

/* SECTION 6 — ROADMAP FILMSTRIP */
export const Roadmap = () => (
  <section className="relative overflow-hidden hairline-t hairline-b" data-testid="roadmap-section">
    <SectionBg img="bg-home-2.jpg" strength={0.93} />
    <SectionParticles variant="houses" count={16} />
    <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 divide-[var(--line)] lg:divide-x">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.1} className="relative p-8 md:p-10 text-left sm:border-b lg:border-b-0 border-[var(--line)]">
          <span
            aria-hidden="true"
            className="font-display font-semibold text-[6rem] md:text-[7.5rem] leading-none text-white/[0.05] absolute top-4 right-4 select-none"
          >
            {s.n}
          </span>
          <div className="relative pt-16">
            <h3 className="font-mono text-sm tracking-[0.24em] text-[var(--accent)] mb-3">
              {s.n} {s.title}
            </h3>
            <p className="text-sm leading-relaxed text-[var(--muted)]">{s.body}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
